import BusinessIcon from '@mui/icons-material/Business';
import MenuIcon from '@mui/icons-material/Menu';
import { Box, IconButton, Stack, Toolbar, Tooltip } from '@mui/material';
import MuiAppBar from '@mui/material/AppBar';
import { grey } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
import * as React from 'react';
import * as Redux from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { BLUE_COLOR, WHITE_COLOR } from '../../../constants/ColorsConst';
import { setActivoEntidadesAction } from '../../../modules/entidad/entidades/EntidadesAction';
import * as ROUTES from '../../../router/Routes';
import { drawerWidth } from '../sidebar';
import ButtonProfile from './ButtonProfile';

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const AppBarTemplate = ({ openSidebar, toggleDrawer }) => {
  const dispatch = Redux.useDispatch();
  let history = useHistory();
  const location = useLocation();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);

  return (
    <AppBar
      position="fixed"
      open={openSidebar}
      sx={{ backgroundColor: BLUE_COLOR }}
    >
      <Toolbar
        sx={{
          pr: '24px', // keep right padding when drawer closed
        }}
      >
        <IconButton
          edge="start"
          color="inherit"
          aria-label="open drawer"
          onClick={toggleDrawer}
          sx={{
            marginRight: '36px',
            ...(openSidebar && { display: 'none' }),
          }}
        >
          <MenuIcon />
        </IconButton>

        {loginStore.isRoot && entidadesStore.activo && (
          <Tooltip describeChild title="CERRAR ENTIDAD" placement="bottom">
            <IconButton
              size="medium"
              aria-label="delete"
              sx={{
                mr: 2,
                backgroundColor: WHITE_COLOR,
                '&:hover': {
                  backgroundColor: 'white',
                },
                '&:active': {
                  backgroundColor: 'white',
                },
              }}
              onClick={() => {
                setActivoEntidadesAction(dispatch, null);
                history.push(ROUTES.entidades.to);
              }}
            >
              <BusinessIcon fontSize="inherit" sx={{ color: BLUE_COLOR }} />
            </IconButton>
          </Tooltip>
        )}

        {loginStore.user.entidades.length > 1 &&
          !location.pathname.includes(ROUTES.misEntidades.to) && (
            <Tooltip
              describeChild
              title="CAMBIAR DE ENTIDAD"
              placement="bottom"
            >
              <IconButton
                size="large"
                aria-label="delete"
                sx={{
                  mr: 2,
                  backgroundColor: WHITE_COLOR,
                  '&:hover': {
                    backgroundColor: grey[200],
                  },
                  '&:active': {
                    backgroundColor: grey[200],
                  },
                }}
                onClick={() => {
                  history.push(ROUTES.misEntidades.to);
                }}
              >
                <BusinessIcon fontSize="inherit" sx={{ color: BLUE_COLOR }} />
              </IconButton>
            </Tooltip>
          )}
        <Stack alignItems="flex-start">
          {entidadesStore.activo && (
            <>
              <strong>
                {entidadesStore.activo.nombre ||
                  entidadesStore.activo.entidad.nombre}
              </strong>
              {entidadesStore.ajustes?.periodoAcademico && (
                <label>
                  Período académico:{'  '}
                  {entidadesStore.ajustes?.periodoAcademico?.desde}
                  {' - '}
                  {entidadesStore.ajustes?.periodoAcademico?.hasta} (
                  {entidadesStore.ajustes?.periodoAcademico?.nombre})
                </label>
              )}
            </>
          )}
        </Stack>

        {/* <SearchAppbar /> */}
        <Box sx={{ flexGrow: 1 }} />
        {/* <Box sx={{ display: { xs: 'none', md: 'flex' } }}> */}
        {/* <IconButton size="large" aria-label="show 4 new mails" color="inherit" sx={{ mr: 0 }}>
                        <Badge badgeContent={4} color="error">
                            <MailIcon />
                        </Badge>
                    </IconButton> */}
        {/* <IconButton
            size="large"
            aria-label="show 17 new notifications"
            color="inherit"
            sx={{ mr: 2 }}
          >
            <Badge badgeContent={17} color="error">
              <NotificationsIcon />
            </Badge>
          </IconButton> */}
        {/* </Box> */}
        <ButtonProfile />
      </Toolbar>
    </AppBar>
  );
};

export default AppBarTemplate;
